export const ZONE = 'America/New_York'
export const ZONE_LABEL = 'ET'

const parts = (d: Date, opts: Intl.DateTimeFormatOptions): Record<string, string> => {
  const out: Record<string, string> = {}
  for (const p of new Intl.DateTimeFormat('en-US', { timeZone: ZONE, ...opts }).formatToParts(d)) out[p.type] = p.value
  return out
}

const ymd = (day: string): [number, number, number] => {
  const [y = 0, m = 1, d = 1] = day.split('-').map(Number)
  return [y, m, d]
}

const YMD = { year: 'numeric', month: '2-digit', day: '2-digit' } as const

/** Today's calendar day in ET, YYYY-MM-DD. */
export function todayEt(now: Date): string {
  const p = parts(now, YMD)
  return `${p.year}-${p.month}-${p.day}`
}

/** ISO UTC instant of ET midnight for a YYYY-MM-DD day (the bound used by history date filters). */
export function startOfDayEtUtc(day: string): string {
  const [y, m, d] = ymd(day)
  const utcMidnight = Date.UTC(y, m - 1, d)
  // ET is UTC-4 (DST) or UTC-5; take the one for which the instant is ET midnight of that day.
  for (const hours of [4, 5]) {
    const t = new Date(utcMidnight + hours * 3_600_000)
    const p = parts(t, { ...YMD, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
    if (`${p.year}-${p.month}-${p.day}` === day && p.hour === '00' && p.minute === '00') return t.toISOString()
  }
  return new Date(utcMidnight + 5 * 3_600_000).toISOString()
}

/** 'Oct 20, 2026 3:05 PM ET' */
export function formatEt(iso: string): string {
  const p = parts(new Date(iso), {
    month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true,
  })
  return `${p.month} ${p.day}, ${p.year} ${p.hour}:${p.minute} ${p.dayPeriod} ${ZONE_LABEL}`
}

/** 'Oct 20, 2026' for a YYYY-MM-DD day (no zone conversion). */
export function formatDateEt(day: string): string {
  const [y, m, d] = ymd(day)
  const month = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short' }).format(new Date(Date.UTC(y, m - 1, d)))
  return `${month} ${d}, ${y}`
}
